/* NG Help — AI shopping & support assistant for ngearsafe.com. Talks to the Apps Script backend. */
(function () {
  var root = document.getElementById("ngh-root");
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";

  var D = root.dataset;
  var ENDPOINT = D.endpoint, KEY = D.key, AVATAR = D.avatar, WA = D.wa || "919265573097";
  var LIVE = /^https:\/\/script\.google\.com\//.test(ENDPOINT || "");
  var PAGE = { type: D.page || "", handle: D.handle || "", title: D.title || "" };
  if (PAGE.type === "product") root.classList.add("ngh-pdp");

  // ---------- storage (survives page navigation within the session) ----------
  function sget(store, k, d) { try { var v = window[store].getItem("ngh_" + k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  function sset(store, k, v) { try { window[store].setItem("ngh_" + k, JSON.stringify(v)); } catch (e) {} }
  var sid = sget("localStorage", "sid", null);
  if (!sid) { sid = "w" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); sset("localStorage", "sid", sid); }
  var hist = sget("sessionStorage", "hist", []);           // [{r:'u'|'a', t}]
  var shown = sget("sessionStorage", "shown", []);         // rendered bubbles to restore [{w, t}]

  // ---------- markup ----------
  // Built into our own shell so a theme/app script that empties or re-renders #ngh-root can't lose it (see watchdog below).
  var shell = document.createElement("div");
  shell.className = "ngh-shell";
  shell.innerHTML =
    '<button class="ngh-launch" type="button" aria-label="Chat with NG Help">' +
      '<span class="ngh-pill" hidden></span><span class="ngh-face" style="background-image:url(' + AVATAR + ')"></span></button>' +
    '<div class="ngh-panel" role="dialog" aria-label="NG Help chat" hidden>' +
      '<div class="ngh-head"><span class="ngh-face" style="background-image:url(' + AVATAR + ')"></span>' +
        '<div><div class="ngh-name">NG Help</div><div class="ngh-sub">AI assistant · replies instantly</div></div>' +
        '<button class="ngh-x" type="button" aria-label="Close chat">×</button></div>' +
      '<div class="ngh-log" aria-live="polite"></div>' +
      '<div class="ngh-quick"></div>' +
      '<form class="ngh-form" autocomplete="off"><input type="text" placeholder="Ask about products, orders, returns…" aria-label="Message" maxlength="800">' +
        '<button class="ngh-send" type="submit" aria-label="Send"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></form>' +
      '<div class="ngh-foot">NG Help is an AI assistant and can make mistakes. Chats are saved to improve service.</div>' +
    '</div>';
  root.appendChild(shell);
  var $ = function (s) { return shell.querySelector(s); };
  // Watchdog: this theme re-renders <body> (at load and after cart changes), which empties #ngh-root.
  // Re-attach the same shell, so listeners, chat history and an open panel all survive. Cheap: two lookups every 1.5 s.
  setInterval(function () {
    var host = document.getElementById("ngh-root");
    if (!host) { host = root; document.body.appendChild(host); }
    if (!host.contains(shell)) host.appendChild(shell);
    if (PAGE.type === "product") host.classList.add("ngh-pdp");
  }, 1500);
  var launch = $(".ngh-launch"), pill = $(".ngh-pill"), panel = $(".ngh-panel"), log = $(".ngh-log"), form = $(".ngh-form"), input = $(".ngh-form input");

  // ---------- helpers ----------
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function md(s) {
    var out = "", list = false;
    esc(s).split(/\n+/).forEach(function (l) {
      l = l.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
      if (/^\s*[-•]\s+/.test(l)) { if (!list) { out += "<ul>"; list = true; } out += "<li>" + l.replace(/^\s*[-•]\s+/, "") + "</li>"; }
      else { if (list) { out += "</ul>"; list = false; } out += "<p>" + l + "</p>"; }
    });
    return out + (list ? "</ul>" : "");
  }
  function inr(n) { return "₹" + Number(n || 0).toLocaleString("en-IN"); }
  function add(el) { log.appendChild(el); log.scrollTop = log.scrollHeight; return el; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function bubble(text, who, keep) {
    var b = add(el("div", "ngh-msg " + (who === "me" ? "ngh-me" : who === "nudge" ? "ngh-bot ngh-nudge" : "ngh-bot"), who === "me" ? esc(text) : md(text)));
    if (keep !== false) { shown.push({ w: who, t: text }); shown = shown.slice(-40); sset("sessionStorage", "shown", shown); }
    return b;
  }
  function sys(text) { return add(el("div", "ngh-sys", esc(text))); }
  function chips(list) {
    if (!list || !list.length) return null;
    var d = el("div", "ngh-chips");
    list.slice(0, 4).forEach(function (c) {
      var b = el("button", "", esc(typeof c === "string" ? c : c[0])); b.type = "button";
      b.onclick = function () { d.remove(); typeof c === "string" ? send(c) : c[1](); };
      d.appendChild(b);
    });
    return add(d);
  }
  function post(body) {
    body.k = KEY; body.sid = sid; body.page = PAGE;
    return fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function track(type, detail, value) { if (LIVE) post({ a: "event", type: type, detail: detail || "", value: value || "" }).catch(function () {}); }
  function waLink() {
    var last = hist.filter(function (h) { return h.r === "u"; }).slice(-2).map(function (h) { return h.t; }).join(" | ");
    var text = "Hi NG EarSafe, I was chatting with NG Help on the website" + (last ? ": " + last.slice(0, 300) : ".") + " (ref " + sid.slice(-6) + ")";
    return "https://wa.me/" + WA + "?text=" + encodeURIComponent(text);
  }

  // ---------- cart ----------
  function cartTitles() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { return (c.items || []).map(function (i) { return i.product_title; }); }).catch(function () { return []; }); }
  function addToCart(p, variantId, btn) {
    btn.disabled = true; btn.textContent = "Adding…";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { ng_help_sid: sid } }) }); })
      .then(function () {
        btn.textContent = "Added ✓";
        track("add_to_cart", p.title, p.price);
        var t = add(el("div", "ngh-chips"));
        var go = el("a", "ngh-btn", "Go to cart & checkout"); go.href = "/cart"; go.onclick = function () { track("checkout_click", p.title, p.price); };
        t.appendChild(go);
      })
      .catch(function () { btn.disabled = false; btn.textContent = "Add to cart"; bubble("Sorry, I couldn't add that to your cart. Please try from the product page.", "bot"); });
  }
  function cards(list) {
    if (!list || !list.length) return;
    var wrap = el("div", "ngh-cards");
    list.forEach(function (p) {
      var off = p.mrp > p.price ? Math.round((1 - p.price / p.mrp) * 100) : 0;
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      var c = el("div", "ngh-card",
        '<a href="' + esc(p.url) + '"><img loading="lazy" alt="" src="' + esc(p.img) + '"></a>' +
        '<div class="ngh-cb"><a class="ngh-nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="ngh-pr"><b>' + inr(p.price) + '</b>' + (off ? "<s>" + inr(p.mrp) + "</s><em>" + off + "% off</em>" : "") + "</div>" +
        '<div class="ngh-st ' + (p.inStock ? "in" : "out") + '">' + (p.inStock ? "In stock · free delivery" : "Out of stock") + "</div>" +
        ((p.variants || []).length > 1 ? "<select aria-label=\"Colour\">" + p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? "" : " disabled") + ">" + esc(v.title) + (v.available ? "" : " (sold out)") + "</option>"; }).join("") + "</select>" : "") +
        '<button class="ngh-btn" type="button"' + (p.inStock ? "" : " disabled") + ">Add to cart</button></div>");
      var sel = c.querySelector("select");
      if (sel && avail.length) sel.value = String(avail[0].id);
      c.querySelector("button").onclick = function () { addToCart(p, sel ? sel.value : (avail[0] || p.variants[0]).id, this); };
      c.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { track("product_click", p.title); }); });
      wrap.appendChild(c);
    });
    add(wrap);
  }
  function compare(list) {
    if (!list || list.length < 2) return;
    var d = el("div", "ngh-box ngh-cmp");
    d.innerHTML = "<h4>Side by side</h4><table><tr><th></th>" + list.map(function (p) { return "<th>" + esc(p.title.replace(/^NG (x WeHear )?|^NG EarSafe /, "")) + "</th>"; }).join("") + "</tr>" +
      "<tr><th>Price</th>" + list.map(function (p) { return "<td>" + inr(p.price) + "</td>"; }).join("") + "</tr>" +
      "<tr><th>Stock</th>" + list.map(function (p) { return "<td>" + (p.inStock ? "In stock" : "Out of stock") + "</td>"; }).join("") + "</tr></table>";
    add(d);
    cards(list);
  }

  // ---------- action cards ----------
  function trackForm() {
    var d = el("div", "ngh-box", "<h4>Track your order</h4><div class=\"ngh-row\"><input inputmode=\"numeric\" placeholder=\"Order ID, e.g. 38791\" aria-label=\"Order ID\"><button class=\"ngh-btn\" type=\"button\">Check status</button></div>");
    var ins = d.querySelectorAll("input"), btn = d.querySelector("button");
    ins[0].addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); btn.click(); } });
    btn.onclick = function () {
      var order = ins[0].value.trim();
      if (!order) { ins[0].focus(); return; }
      btn.disabled = true; btn.textContent = "Checking…";
      bubble("Track order " + order, "me");
      var t = typing();
      post({ a: "track", order: order }).then(function (r) {
        t.remove(); btn.disabled = false; btn.textContent = "Check status";
        if (!r.found) { bubble(r.message || "I couldn't find that order.", "bot"); chips([["Chat on WhatsApp", openWA], "Try another order"]); return; }
        d.remove();
        var box = el("div", "ngh-box", "<h4>Order " + esc(r.order) + "</h4><div class=\"ngh-kv\">" +
          "<span>Status</span><b>" + esc(r.status) + "</b>" +
          (r.location ? "<span>Location</span><span>" + esc(r.location) + "</span>" : "") +
          (r.updated ? "<span>Updated</span><span>" + esc(r.updated) + "</span>" : "") +
          "<span>Placed</span><span>" + esc(r.placed) + "</span>" +
          (r.items && r.items.length ? "<span>Items</span><span>" + esc(r.items.join(", ")) + "</span>" : "") +
          "</div>" + (r.trackUrl ? '<a class="ngh-btn ghost" target="_blank" rel="noopener" href="' + esc(r.trackUrl) + '">Open courier tracking</a>' : ""));
        add(box);
        var line = "Your order **" + r.order + "** is **" + r.status + "**" + (r.location ? " (" + r.location + ")" : "") + "." + (r.note ? " " + r.note : "");
        bubble(line, "bot");
        hist.push({ r: "a", t: line.replace(/\*\*/g, "") }); sset("sessionStorage", "hist", hist);
        chips(["When will it arrive?", ["Cancel this order", function () { cancelForm(order); }], ["Return or warranty claim", claimForm], ["Chat on WhatsApp", openWA]]);
      }).catch(function () { t.remove(); btn.disabled = false; btn.textContent = "Check status"; bubble("I couldn't check that right now. Please message us on WhatsApp.", "bot"); });
    };
    add(d); ins[0].focus();
  }
  function openWA() {
    track("whatsapp_click", "handoff");
    var d = el("div", "ngh-box", "<h4>Chat with our team on WhatsApp</h4><div>+91 92655 73097 · Mon–Sat, 10:30am–6:30pm. Your chat summary goes with you, so you don't have to repeat yourself.</div>");
    var a = el("a", "ngh-btn wa", "Open WhatsApp"); a.href = waLink(); a.target = "_blank"; a.rel = "noopener";
    d.appendChild(a); add(d);
  }
  var CLAIM_URL = "/pages/claim-warranty";
  function claimForm() {
    track("claim_form_shown");
    var d = el("div", "ngh-box", "<h4>Return, replacement or warranty claim</h4><div>Fill in this short form and our team will start the process. It works for website orders, Amazon/Flipkart orders, 7-day returns and warranty claims within 1 year.</div><div>We offer <b>door-to-door service</b>: we pick the product up from your address, check it at our warehouse and ship a new unit. Physical damage isn't covered.</div>");
    var a = el("a", "ngh-btn", "Open the claim form"); a.href = CLAIM_URL; a.target = "_blank"; a.rel = "noopener";
    a.onclick = function () { track("claim_form_click"); };
    d.appendChild(a); add(d);
  }
  var CANCEL_REASONS = ["Ordered by mistake", "Found a better price", "Delivery is taking too long", "Changed my mind", "Want a different product", "Wrong address or details", "Other"];
  function cancelForm(prefill) {
    track("cancel_form_shown");
    var d = el("div", "ngh-box", "<h4>Cancel an order</h4><input inputmode=\"numeric\" placeholder=\"Order ID, e.g. 38791\" aria-label=\"Order ID\">" +
      "<select aria-label=\"Reason for cancelling\"><option value=\"\">Reason for cancelling…</option>" + CANCEL_REASONS.map(function (r) { return "<option>" + esc(r) + "</option>"; }).join("") + "</select>" +
      "<input maxlength=\"200\" placeholder=\"Anything we should know? (optional)\" aria-label=\"Details\"><button class=\"ngh-btn\" type=\"button\">Request cancellation</button>");
    var ins = d.querySelectorAll("input"), sel = d.querySelector("select"), btn = d.querySelector("button");
    if (prefill) ins[0].value = String(prefill).replace(/\D/g, "");
    btn.onclick = function () {
      var order = ins[0].value.trim(), reason = sel.value, details = ins[1].value.trim();
      if (!order) { ins[0].focus(); return; }
      if (!reason) { sel.focus(); return; }
      btn.disabled = true; btn.textContent = "Checking…";
      var mine = "Cancel order " + order + " (" + reason + ")";
      bubble(mine, "me");
      var t = typing();
      post({ a: "cancel", order: order, reason: reason, details: details }).then(function (r) {
        t.remove(); btn.disabled = false; btn.textContent = "Request cancellation";
        var msg = r.message || "I couldn't process that. Please message us on WhatsApp.";
        bubble(msg, "bot");
        hist.push({ r: "u", t: mine }, { r: "a", t: msg }); hist = hist.slice(-20); sset("sessionStorage", "hist", hist);
        if (r.state === "invalid" || r.state === "not_found") { ins[0].focus(); chips([["Chat on WhatsApp", openWA]]); return; }
        d.remove();
        track("cancel_" + (r.state || "unknown"), order);
        if (r.next === "claim_form") claimForm();
        else if (r.next === "whatsapp") openWA();
        else chips(["Track another order", ["Chat on WhatsApp", openWA]]);
      }).catch(function () { t.remove(); btn.disabled = false; btn.textContent = "Request cancellation"; bubble("I couldn't check that right now. Please message us on WhatsApp.", "bot"); chips([["Chat on WhatsApp", openWA]]); });
    };
    add(d); ins[0].focus();
  }
  function leadForm() {
    var d = el("div", "ngh-box", "<h4>Bulk / corporate order</h4><div class=\"ngh-row\"><input placeholder=\"Name / company\"><input inputmode=\"tel\" placeholder=\"Phone\"></div><div class=\"ngh-row\"><input inputmode=\"numeric\" placeholder=\"Quantity\"><input placeholder=\"Product / occasion\"></div><button class=\"ngh-btn\" type=\"button\">Request a quote</button>");
    var ins = d.querySelectorAll("input");
    d.querySelector("button").onclick = function () {
      if (!ins[1].value.trim()) { ins[1].focus(); return; }
      post({ a: "lead", name: ins[0].value, phone: ins[1].value, qty: ins[2].value, need: ins[3].value }).catch(function () {});
      d.remove();
      bubble("Thanks! Our B2B team will call you with bulk pricing within one working day.", "bot");
    };
    add(d);
  }
  var QUIZ = [
    ["What will you use it for most?", ["Running / gym", "Calls & work", "Commute & travel", "Swimming", "Sleeping"]],
    ["Which style do you like?", ["Earbuds with case", "Headset with mic", "Neckband", "Bone conduction", "No preference"]],
    ["Your budget?", ["Under ₹1,000", "Up to ₹3,000", "Up to ₹7,000", "Show me the best"]]
  ];
  function quiz() {
    var ans = [];
    track("quiz_start");
    (function step(i) {
      if (i === QUIZ.length) { track("quiz_done", ans.join(" / ")); return send("Help me pick. Use: " + ans[0] + ". Style: " + ans[1] + ". Budget: " + ans[2] + ". Recommend the best 1–2 for me.", true); }
      bubble(QUIZ[i][0], "bot");
      chips(QUIZ[i][1].map(function (o) { return [o, function () { bubble(o, "me"); ans.push(o); step(i + 1); }]; }));
    })(0);
  }
  function typing() { return add(el("div", "ngh-msg ngh-bot ngh-typing", "<i></i><i></i><i></i>")); }

  // ---------- chat ----------
  var busy = false;
  function send(text, hideMine) {
    text = String(text || "").trim();
    if (!text || busy) return;
    if (/^(try another order|track another order)$/i.test(text)) return trackForm();
    log.querySelectorAll(".ngh-chips").forEach(function (c) { if (!c.querySelector("a")) c.remove(); }); // old suggestions go stale once the shopper types
    if (!hideMine) bubble(text, "me");
    if (!LIVE) { bubble("NG Help isn't connected yet. Message us on WhatsApp at +91 92655 73097.", "bot"); return; }
    busy = true;
    var t = typing();
    cartTitles().then(function (cart) {
      return post({ a: "chat", msg: text, hist: hist.slice(-10), cart: cart });
    }).then(function (r) {
      t.remove(); busy = false;
      hist.push({ r: "u", t: text }, { r: "a", t: r.reply || "" }); hist = hist.slice(-20); sset("sessionStorage", "hist", hist);
      bubble(r.reply || "Sorry, could you say that again?", "bot");
      if (r.compare && r.compare.length > 1) compare(r.compare); else cards(r.products);
      if (r.action === "track_order") trackForm();
      else if (r.action === "whatsapp") openWA();
      else if (r.action === "lead_form") leadForm();
      else if (r.action === "claim_form") claimForm();
      else if (r.action === "cancel_order") cancelForm();
      else if (r.action === "quiz") quiz();
      chips(r.chips);
    }).catch(function () {
      t.remove(); busy = false;
      bubble("I'm having trouble connecting. You can reach our team on WhatsApp at +91 92655 73097.", "bot");
      chips([["Chat on WhatsApp", openWA]]);
    });
  }
  form.addEventListener("submit", function (e) { e.preventDefault(); var v = input.value; input.value = ""; send(v); });

  [["Find my pair", quiz], ["Track order", function () { bubble("Track my order", "me"); trackForm(); }], ["Best-sellers", function () { send("Show me your best-sellers"); }], ["WhatsApp us", openWA, "wa"]].forEach(function (q) {
    var b = el("button", q[2] || "", esc(q[0])); b.type = "button"; b.onclick = q[1]; $(".ngh-quick").appendChild(b);
  });

  // ---------- open / close ----------
  var opened = false;
  function open() {
    panel.hidden = false; launch.hidden = true; pill.hidden = true;
    sset("sessionStorage", "open", true);
    if (!opened) {
      opened = true;
      track("open", PAGE.handle || PAGE.type);
      if (shown.length) { shown.forEach(function (s) { bubble(s.t, s.w, false); }); sys("Earlier in this visit"); }
      else greet();
    }
    setTimeout(function () { if (window.innerWidth > 600) input.focus(); }, 50);
  }
  function close() { panel.hidden = true; launch.hidden = false; sset("sessionStorage", "open", false); }
  function greet() {
    if (PAGE.handle && PAGE.title) {
      bubble("Hi! 👋 I'm **NG Help**. Got a question about **" + PAGE.title + "**? Ask me anything: fit, sound, calls, battery or delivery.", "bot");
      chips(["Does it work with iPhone?", "Is it good for calls?", "Battery life?", "Delivery & COD?"]);
    } else {
      bubble("Hi! 👋 I'm **NG Help**, NG EarSafe's AI assistant. I can help you pick open-ear audio for **workouts, calls, commuting or sleep**, track an order with just your order ID, or start a return or warranty claim.\n\nWhat are you looking for today?", "bot");
      chips(["Running", "Office calls", "Gift ideas", ["Take the 3-tap quiz", quiz]]);
    }
  }
  launch.addEventListener("click", open);
  $(".ngh-x").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) close(); });
  if (sget("sessionStorage", "open", false)) open();
  // 4 Nov 2026: the launcher (avatar) appears 5 s after load, so the first screen (title, price, Buy now) is clear.
  // The greeting bubble has its own delay below (10 s on product pages, 40 s elsewhere).
  shell.classList.add("ngh-wait");
  setTimeout(function () { shell.classList.remove("ngh-wait"); }, 5000);

  // ---------- smart nudge: one gentle prompt per visit ----------
  if (!sget("sessionStorage", "nudged", false)) {
    setTimeout(function () {
      if (!panel.hidden || sget("sessionStorage", "nudged", false)) return;
      sset("sessionStorage", "nudged", true);
      pill.textContent = PAGE.title ? "Questions about " + PAGE.title.replace(/^NG (x WeHear )?|^NG EarSafe /, "") + "? Ask me" : "Need help choosing? Ask NG Help";
      pill.hidden = false;
      track("nudge_shown", PAGE.handle || PAGE.type);
    }, PAGE.type === "product" ? 10000 : 40000);  // 4 Nov 2026: product pages 25 s -> 10 s (owner)
  }
  window.NGHelp = { open: open, close: close };
})();
